module.exports = __webpack_public_path__ + "web/img/sign-40.f1e9d973.png";